import {
  CardWithIcon,
  ContentSection,
  Heading,
  SvgIconProps,
  Text,
} from '@cinch-labs/design-system'
import { useViewport } from '@cinch-labs/shared-util'
import { StoryBlokRichText } from '@cinch-nx/data-storyblok'

import renderWithResolver from '../rich-text-renderer/rich-text-renderer'
import TitleWithLogo from '../title-with-logo/title-with-logo'
import styles from './feature-icon-card-section.module.css'

export interface FeatureIconCardSectionProps {
  headingLeftText?: string
  headingRightText?: string
  headingLogo?: 'cinchShield' | 'cinchCharge' | 'cinchChargePurple'
  cards: FeatureIconCard[]
  body: StoryBlokRichText
}

export interface FeatureIconCard {
  icon: SvgIconProps['name']
  heading: string
  body: StoryBlokRichText
}

const FeatureIconCardSection: React.FC<FeatureIconCardSectionProps> = ({
  headingLeftText,
  headingRightText,
  headingLogo,
  cards,
  body,
}) => {
  const { vw } = useViewport({
    updateOnResize: true,
    updateOnOrientationChange: true,
  })
  const isMobile = vw < 1024

  return (
    <section
      className={styles.container}
      data-testid="feature-icon-card-section"
    >
      <div className={styles.innerContainer}>
        <div className={styles.titleWrapper}>
          <TitleWithLogo
            headingLevel={'h3'}
            leftText={headingLeftText}
            rightText={headingRightText}
            textClassName={styles.title}
            logo={headingLogo}
            logoHeight={isMobile ? '28' : '36'}
            logoWidth={isMobile ? '142' : '182'}
          />
        </div>

        <div className={styles.cardsWrapper}>
          {cards.map((card, index) => (
            <div key={'step ' + index + 1} className={styles.singleCardWrapper}>
              <CardWithIcon
                iconName={card.icon}
                iconGradient="galaxy"
                iconSize={32}
              />
              <Text className={styles.stepNumber}>{'STEP ' + (index + 1)}</Text>
              <Heading className={styles.cardHeading}> {card.heading}</Heading>
              <ContentSection
                sectionWrapperClass={styles.sectionWrapper}
                classNames={{ body: styles.cardBody }}
              >
                {renderWithResolver(card.body)}
              </ContentSection>
            </div>
          ))}
        </div>
        <ContentSection
          sectionWrapperClass={styles.bodySectionWrapper}
          classNames={{ body: styles.body }}
        >
          {renderWithResolver(body)}
        </ContentSection>
      </div>
    </section>
  )
}

export default FeatureIconCardSection
